export enum DriverLicenceType {
    FULL_IRISH_LICENCE = 'D',
    PROVISIONAL_IRISH_LICENCE = "G",
    FULL_UK_LICENCE = "F",
    FULL_EU_OTHER_THAN_IRISH_UK = "E"
}